<script lang="ts">
import {Options, Vue} from "vue-class-component";
import {trackAjanlatkeres} from "@/gtag";

@Options({
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      contacts: [
        {
          icon: "mdi-email-outline",
          label: "E-mail",
          value: "info@himzokucko.hu",
          href: "mailto:info@himzokucko.hu",
          copy: "info@himzokucko.hu",
          conversion: "E-mail"
        },
        {
          icon: "mdi-phone-outline",
          label: "Telefon",
          value: "+36 30 5705 139",
          href: "tel:+36305705139",
          copy: "+36 30 5705 139",
          conversion: "Telefon"
        },
        {
          icon: "mdi-facebook",
          label: "Facebook",
          value: "kreativhimzokucko",
          href: "https://www.facebook.com/kreativhimzokucko",
          external: true
        },
        {
          icon: "mdi-map-marker-outline",
          label: "Telephely",
          value: "6100 Kiskunfélegyháza, Róna utca 17.",
          href: "http://maps.google.com/?q=6100 Kiskunfélegyháza Róna utca 17, Magyarország",
          external: true
        },
      ]
    };
  },
  methods: {
    /** Az e-mail / telefon kártya kattintása számít "Ajánlatkérés" konverziónak. */
    onContactClick(c: { conversion?: string }): void {
      if (c.conversion) {
        trackAjanlatkeres(c.conversion);
      }
    },
    addToClipboard(text: string, conversion?: string): void {
      if (!navigator.clipboard) {
        this.snackbar = true;
        this.snackbarText = "Nem sikerült a vágólapra másolás! Nem biztonságos kapcsolat";
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
        this.snackbar = true;
        this.snackbarText = "Vágólapra másolva!";
        if (conversion) {
          trackAjanlatkeres(conversion + " másolás");
        }
      }, (err) => {
        this.snackbar = true;
        this.snackbarText = "Nem sikerült a vágólapra másolás! " + err.message;
      });
    }
  }
})
export default class ConnectionRow extends Vue {
}
</script>

<template>
  <v-snackbar v-model="snackbar" timeout="2000" color="secondary">{{ snackbarText }}</v-snackbar>

  <v-row justify="center">
    <v-col v-for="(c, i) in contacts" :key="i" cols="12" sm="6" lg="3">
      <v-card
          class="hk-card hk-card--hover contact-card pa-6 h-100"
          :href="c.href"
          :target="c.external ? '_blank' : undefined"
          @click="onContactClick(c)"
      >
        <div class="contact-card__icon">
          <v-icon :icon="c.icon" size="34"></v-icon>
        </div>
        <div class="contact-card__label">{{ c.label }}</div>
        <div class="contact-card__value">{{ c.value }}</div>
        <v-btn
            v-if="c.copy"
            class="mt-3"
            size="small"
            variant="tonal"
            color="secondary"
            prepend-icon="mdi-content-copy"
            @click.prevent.stop="addToClipboard(c.copy, c.conversion)"
        >
          Másolás
        </v-btn>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
.contact-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  text-decoration: none;
}

.contact-card__icon {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  background: rgba(226, 76, 130, 0.12);
  color: var(--hk-primary);
}

.contact-card__label {
  font-family: 'Playfair Display', Georgia, serif;
  font-weight: 700;
  font-size: 1.2rem;
  color: var(--hk-ink);
  margin-bottom: 0.35rem;
}

.contact-card__value {
  font-size: 0.98rem;
  color: var(--hk-ink-soft);
  word-break: break-word;
}
</style>
